import { styled, TextField, Button, Grid } from "@mui/material"

export const StyledContractList = {
    ActionButton: styled(Button, {
        shouldForwardProp: (prop) => prop !== "loading",
    })<{ loading?: boolean }>(({ theme, loading }) => ({
        background: theme.palette.common.white,
        position: "relative",
        marginTop: 0,
        minWidth: 160,
        "& .MuiCircularProgress-root": {
            display: loading === true ? "block" : "none",
            position: "absolute",
        },
        "& span:not(.MuiCircularProgress-root)": {
            visibility: loading === true ? "hidden" : "visible",
        },
    })),
    HeaderContainer: styled(Grid)(() => ({
        marginTop: "24px",
    })),

    ButtonsContainer: styled(Grid)(({ theme }) => ({
        display: "flex",
        alignItems: "stretch",
        justifyContent: "flex-end",
        [theme.breakpoints.down("md")]: {
            marginTop: "16px",
        },
        [theme.breakpoints.up("md")]: {
            marginTop: "8px",
        },
    })),

    SearchField: styled(TextField)(({ theme }) => ({
        minWidth: "320px",
        background: theme.palette.common.white,
        marginTop: "8px",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
        [theme.breakpoints.up("sm")]: {
            width: "550px",
        },
    })),

    ButtonContainerLargeScreen: styled("div")(() => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
        marginTop: "10px",
    })),
}
